import axios from "axios";
import { AssessmentTemplateQuestion } from "../../model/assessment";

export const doTemplateQuestionsFetchApiCall = ({
  companyId,
}: {
  companyId: number;
}) => {
  return axios.get<AssessmentTemplateQuestion[]>(
    `/api/companies/${companyId}/template_questions`
  );
};
